import React, { useState } from 'react';
import { createDispute } from '../../services/disputeService';
import './CreateDisputeForm.css';

interface CreateDisputeFormProps {
  transactionId: string;
  onClose: () => void;
  onSuccess: (disputeId: string) => void;
}

const CreateDisputeForm: React.FC<CreateDisputeFormProps> = ({
  transactionId,
  onClose,
  onSuccess
}) => {
  const [reason, setReason] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!reason.trim()) {
      setError('Please provide a reason for the dispute');
      return;
    }
    
    setIsSubmitting(true);
    setError(null);
    
    try {
      const disputeData = {
        transactionId,
        reason,
        message: message.trim() || undefined
      };
      
      const response = await createDispute(disputeData) as any;
      onSuccess(response.id);
    } catch (err: any) {
      setError(err.message || 'Failed to create dispute');
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
    <div className="create-dispute-modal">
      <div className="create-dispute-content">
        <div className="create-dispute-header">
          <h2>Create Dispute</h2>
          <button className="create-dispute-close-button" onClick={onClose}>&times;</button>
        </div>
        
        {error && (
          <div className="create-dispute-alert create-dispute-alert-danger">
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="create-dispute-form-group">
            <label htmlFor="reason">Reason for Dispute:</label>
            <textarea
              id="reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Please explain why you are disputing this transaction. Be detailed and specific."
              required
              maxLength={1000}
              rows={4}
            />
          </div>
          
          {/* <div className="create-dispute-form-group">
            <label htmlFor="message">Initial Message (optional):</label>
            <textarea
              id="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Provide any additional details or context"
              maxLength={2000}
              rows={4}
            />
          </div> */}
          
          <div className="create-dispute-form-actions">
            <button type="button" className="create-dispute-btn create-dispute-btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="create-dispute-btn create-dispute-btn-primary" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Submit Dispute'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateDisputeForm;